"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusOneForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const ReactDOM = require("react-dom");
const react_google_recaptcha_1 = require("react-google-recaptcha");
const app_1 = require("app");
const types_1 = require("./types");
const Forms_1 = require("../Forms");
const PlusOneFormUtils_1 = require("./PlusOneFormUtils");
const webexUI_1 = require("webexUI");
const FormikConfig_1 = require("../FormikFields/FormikConfig");
const RecaptchaComponent = react_google_recaptcha_1.default;
class PlusOneForm extends React.Component {
    componentWillUnmount() {
        app_1.GTM.newsletter.abandon(this.gtmData);
    }
    constructor(props) {
        super(props);
        this.modalSelector = '.plus-one-modal';
        this.formSubmissionGuardPassed = false;
        this.formRef = React.createRef();
        this.formInputRef = React.createRef();
        this.recaptchaRef = React.createRef();
        this.gtmData = (() => {
            const { title, control, formType } = this.props;
            return {
                label: formType,
                title,
                control,
            };
        })();
        this.prepareInputData = (input, onChange) => {
            const { name } = input;
            const stateValue = this.state[String(name).toLocaleLowerCase()];
            return PlusOneFormUtils_1.plusOneFormUtils.generateInputs(input, stateValue, onChange);
        };
        this.submitForm = event => {
            const { bypassRecaptchaKey } = this.props;
            const recaptchaBypass = (0, FormikConfig_1.recaptchaKeyGuard)(bypassRecaptchaKey);
            event.preventDefault();
            const isValid = this.validate();
            if (!isValid) {
                return;
            }
            this.formSubmissionGuardPassed = true;
            recaptchaBypass ? this.formSubmit() : this.performReCaptchaCheck();
        };
        this.validate = () => {
            const { formItemsLeft, formItemsRight } = this.props;
            const inputs = [...formItemsLeft, ...formItemsRight];
            const { file } = this.state;
            const newStateChanges = {};
            let formValid = true;
            inputs.map(input => {
                const { required, name } = input;
                const stateValue = this.state[String(name).toLocaleLowerCase()];
                const isEmail = String(name).toLocaleLowerCase() === 'email';
                if (required && !stateValue.value && !isEmail) {
                    formValid = false;
                    newStateChanges[String(name).toLocaleLowerCase()] = Object.assign(Object.assign({}, stateValue), { hasError: true });
                }
                if (isEmail) {
                    const emailValid = Boolean((0, Forms_1.validateEmail)(stateValue.value));
                    newStateChanges[String(name).toLocaleLowerCase()] = Object.assign(Object.assign({}, stateValue), { hasError: !emailValid });
                    formValid = emailValid;
                }
                if (file.hasError) {
                    formValid = false;
                }
            });
            if (!formValid) {
                app_1.GTM.newsletter.error(Object.assign(Object.assign({}, this.gtmData), { errorType: types_1.ErrorType.validationError }));
            }
            this.setState(Object.assign(Object.assign({}, newStateChanges), { formValid }));
            return formValid;
        };
        this.handleOnChange = ({ target: { name, value } }) => {
            const newStateChanges = {
                [String(name).toLocaleLowerCase()]: {
                    hasError: false,
                    value,
                },
            };
            this.setState(Object.assign(Object.assign({}, this.state), newStateChanges));
        };
        this.handleCheckboxChange = (e) => {
            const newStateChanges = {
                userconsent: {
                    hasError: false,
                    value: e,
                },
            };
            this.setState(Object.assign({}, newStateChanges));
        };
        /*
          When recaptcha throws errors (most likely due to network issues) and form validation already
          passed we will send form with empty token. This should result with error response from BE.
        */
        this.onReCaptchaError = () => {
            if (this.formSubmissionGuardPassed) {
                this.formSubmit();
            }
        };
        this.performReCaptchaCheck = () => {
            const captchaEl = this.recaptchaRef.current;
            const reCaptchaInitialized = captchaEl.getWidgetId() !== null;
            if (reCaptchaInitialized) {
                captchaEl.execute();
            }
            else {
                /*
                  When recaptcha widget is not initialized due to network issues
                  we send form with empty token. This should result with error response from BE.
                */
                this.formSubmit();
            }
        };
        this.formSubmit = (recaptchaToken = '') => {
            const form = this.formRef.current;
            const disabled = $(form).find(':input:disabled').removeAttr('disabled');
            const formData = $(form).serializeArray();
            const { culture } = this.props;
            const resetFieldsValues = PlusOneFormUtils_1.plusOneFormUtils.resetFormValues(this.state);
            const foundIndex = formData.findIndex(input => input.name == types_1.InputName.PRODUCT);
            const { file: { value }, userconsent, fileName, } = this.state;
            // Modify Product value
            disabled.attr('disabled', 'disabled');
            formData[foundIndex].value = PlusOneFormUtils_1.plusOneFormUtils.getCurrentOptionValue(formData[foundIndex].value);
            // Reset state values
            this.setState(Object.assign(Object.assign(Object.assign({}, this.state), resetFieldsValues), { formValid: false }));
            // Reset recaptcha
            this.recaptchaRef.current.reset();
            this.renderLoader();
            // File in base64 format and recaptcha token
            formData.push({ name: 'Attachment', value: String(value) }, {
                name: 'g-recaptcha-response',
                value: recaptchaToken,
            }, { name: 'culture', value: culture }, { name: 'userConsent', value: String(userconsent.value) }, { name: 'fileName', value: fileName });
            const formString = $.param(formData);
            (0, app_1.apiPost)(`${this.props.apiUrl}`, formString).then(() => {
                app_1.GTM.newsletter.subscribe(this.gtmData);
                // Display success message
                this.renderMessage(true);
            }, () => {
                app_1.GTM.newsletter.error(Object.assign(Object.assign({}, this.gtmData), { errorType: types_1.ErrorType.serverError }));
                // Display error message
                this.renderMessage(false);
            });
        };
        this.renderMessage = (status) => {
            const { formMessages: { successMessageTitle, successMessage, errorMessage }, } = this.props;
            PlusOneFormUtils_1.plusOneFormUtils.renderMessageModal((0, jsx_runtime_1.jsx)("div", { children: (0, app_1.StringToHTML)(status ? successMessage : '') }), this.modalWrapper, status ? successMessageTitle : errorMessage, 'plus-one-form-modal group');
        };
        this.renderLoader = () => {
            PlusOneFormUtils_1.plusOneFormUtils.renderMessageModal((0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { visible: true }), this.modalWrapper, null, 'plus-one-form-modal group');
        };
        this.modalWrapper = $(this.modalSelector).get(0);
        this.state = PlusOneFormUtils_1.plusOneFormUtils.getInitialState();
    }
    render() {
        const { title, formItemsLeft, formItemsRight, reCaptchaSiteKey, formMessages: { instructionSubmit, instructionMandatory, instructionEmail }, } = this.props;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid md:grid-cols-12 gap-6", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-span-2", children: (0, jsx_runtime_1.jsx)("img", { src: "/static/images/cookie-logo.png", alt: "logo", loading: "lazy" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "col-span-10 plus-one-form__title", children: [(0, jsx_runtime_1.jsx)("h3", { className: "pb-6 max-md:pb-4", children: title }), (0, jsx_runtime_1.jsx)("p", { children: instructionSubmit }), (0, jsx_runtime_1.jsx)("p", { children: instructionMandatory }), (0, jsx_runtime_1.jsx)("p", { children: instructionEmail })] })] }), (0, jsx_runtime_1.jsxs)("form", { id: "plusOneForm", className: "clearfix mt-12", ref: this.formRef, onSubmit: this.submitForm, children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid md:grid-cols-2 gap-x-6 gap-y-4", children: [this.renderInputs(formItemsLeft), this.renderInputs(formItemsRight)] }), (0, jsx_runtime_1.jsx)("div", { className: "grid md:grid-cols-2 gap-6 plus-one-form-submit", children: (0, jsx_runtime_1.jsx)("div", { className: "col-span-2 flex pt-6 max-md:pt-4", children: (0, jsx_runtime_1.jsx)("button", { className: "cta cta--large cta--alpha btn-primary btn-large ml-auto", type: "submit", children: "Submit" }) }) }), ReactDOM.createPortal((0, jsx_runtime_1.jsx)(RecaptchaComponent, { className: "newsletter-recaptcha recaptcha-mounted", ref: this.recaptchaRef, size: "invisible", sitekey: reCaptchaSiteKey, onChange: this.formSubmit, onErrored: this.onReCaptchaError }), document.body)] })] }));
    }
    renderInputs(data) {
        const { userconsent } = this.state;
        const { userConsentValidationText } = this.props.formMessages;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: data.map((input) => ((0, jsx_runtime_1.jsx)("div", { className: `${input.width} plus-one-form__input`, children: (0, jsx_runtime_1.jsx)("div", { children: PlusOneFormUtils_1.plusOneFormUtils.convertInputs(input, userconsent, userConsentValidationText, this.formInputRef, this.prepareInputData, this.handleOnChange, this.handleCheckboxChange) }) }, input.id))) }));
    }
}
exports.PlusOneForm = PlusOneForm;
